(function () {
  function bind(card) {
    var video = card.querySelector('.category-card__video');
    if (!video || video.dataset.hoverBound) return;
    video.dataset.hoverBound = '1';

    // Slow the clip down so the motion reads as a gentle drift, not a bounce
    var speed = parseFloat(video.dataset.speed);
    if (!speed || speed <= 0) speed = 1;
    var applySpeed = function () { try { video.playbackRate = speed; } catch (e) {} };
    applySpeed();
    video.addEventListener('loadedmetadata', applySpeed);

    var play = function () {
      applySpeed();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    };
    var stop = function () {
      video.pause();
      video.currentTime = 0;
    };

    // Hover (desktop) and keyboard focus play the clip; otherwise the poster shows.
    card.addEventListener('mouseenter', play);
    card.addEventListener('mouseleave', stop);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', stop);
  }

  function init(root) {
    (root || document).querySelectorAll('.category-card').forEach(bind);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  // Re-bind when re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
